import axios from '@/config/axios.config';
import { logEvent } from '@/helpers/cieloLogger';
import vars from '@/config/vars';

import mocked from '@/mockedPreorder';

export default {
    namespaced: true,
    
    state: {
        Id: null,
        MerchantName: null,
        OrderNumber: null,
        TestModeEnabled: null,
        TransactionIsFinalized: false,
        TransactionResponse: null,
        IsLoaded: false,
        DebitCardAleloPaymentMethod: null,
        HasPreorder: false
    },

    actions: {
        async fetchPreorder({
            commit,
            dispatch
        }, preorderId) {
            commit('setIsLoaded', false);

            try {
                let response;

                if (vars.USE_SIMULATED_MODE)
                    response = await new Promise(resolve => setTimeout(() => resolve({data: mocked}), 3000));
                else
                    response = await axios.get(`/preorder/${preorderId}`);

                let data = response.data;
                
                // Atualiza os módulos com base no response.
                commit('preorder/setFromRequest', data, { root: true });
                commit('antifraud/setFromRequest', data, { root: true });
                commit('payment/setFromRequest', data, { root: true });
                commit('recurrentPayment/setFromRequest', data, { root: true });
                commit('cart/setFromRequest', data, { root: true });
                commit('shoppingCart/setFromRequest', data, { root: true });
                commit('shippingAddress/setFromRequest', data.ShippingAddress, { root: true });
                commit('shippingType/setFromRequest', data.ShippingMethod, { root: true });
                commit('shippingType/setShippingType', data.ShippingType, { root: true });
                commit('mpi/setFromRequest', data, { root: true });              
                commit('paymentTypes/setFromRequest', data.PaymentType, { root: true });
                commit('merchantLayout/setFromRequest', data.MerchantLayoutConfiguration, { root: true });
                commit('customer/setFromRequest', data.Customer, { root: true });

                //Custom wallets
                commit('googlePayPayment/setFromRequest', data, { root: true });
                commit('clickToPayPayment/setFromRequest', data, { root: true });
                commit('applePayPayment/setFromRequest', data, { root: true });
                
                //Default wallets buttons
                commit('walletTypes/setFromRequest', data, { root: true });

                // Inicia o script do fingerprint antifraud
                dispatch('antifraud/loadAntifraudScript', null, { root: true });

                // Atualiza o preço total, deve sempre vir por último.
                dispatch('payment/updateTotalPrice', null, { root: true });
                commit('setIsLoaded', true);

                logEvent({
                    category: 'Preorder',
                    action: 'Fetch Preorder',
                    label: 'Preorder carregada com sucesso'
                });
            }
            catch (error) {
                logEvent({
                    category: 'Preorder',
                    action: 'Fetch Preorder',
                    label: `[ERROR]: ${error}`
                });

                throw error;
            }
        }
    },

    getters: {
        /**
         * Pega a primeira letra do nome do merchant para montar o logo
         */
        getMerchantTextLogo: state => (state.MerchantName) ? state.MerchantName[0] : '',

        /**
         * Retorna o OrderId que veio na resposta da transação
         */
        getOrderNumber: state => state.TransactionResponse? state.TransactionResponse.OrderNumber : '',

        /**
         * Retorna o CreatedDate que veio na resposta da transação
         */
        getOrderDate: state => state.TransactionResponse? state.TransactionResponse.CreatedDate : '',

        /**
         * Verifica se a preordem já foi buscada no servidor
         */
        hasPreorderBeenFetched: state => (state.Id != null) && (state.MerchantName != null),

        /**
         * Monta o contrato de autorização
         */
        getSubmitModel(state) {
            return {
                preorderId: state.Id
            };
        },

        hasPreorder: state => state.HasPreorder
    },

    mutations: {
        /**
         * Mapeia o response da api para o módulo
         */
        setFromRequest(state, data) {
            state.Id = data.PreorderId;
            state.MerchantName = data.MerchantName;
            state.OrderNumber = data.OrderNumber;
            state.TestModeEnabled = data.MerchantLayoutConfiguration.TestModeEnabled;
            state.DebitCardAleloPaymentMethod = data.DebitCardAleloPaymentMethod;
            state.HasPreorder = true;
        },

        setTransactionAsFinalized(state) {
            state.TransactionIsFinalized = true;
        },

        setTransactionSuccessfulResponse(state, response) {
            state.TransactionResponse = {
                ...response
            };
        },

        setIsLoaded(state, data) {
            state.IsLoaded = data;
        }
    }
};
